<template>
    <div class="px-6 py-4 border-b border-gray-200">
        <slot></slot>
    </div>
</template>

<script>
    export default {

    }
</script>
